import type { UncertaintyLevel } from "@shared/schema";
import { Tooltip } from "../ui/tooltip";
import { cn } from "@/lib/utils";

const META: Record<UncertaintyLevel, { label: string; color: string; explain: string }> = {
  low: {
    label: "low uncertainty",
    color: "hsl(var(--uncertainty-low))",
    explain:
      "Multiple independent lines of evidence agree — either ≥3 STRING channels above threshold or a direct experimental/curated record, with at least one orthologue confirmed.",
  },
  moderate: {
    label: "moderate uncertainty",
    color: "hsl(var(--uncertainty-moderate))",
    explain:
      "Mixed evidence — either a single channel above threshold, or multiple weak channels. Cross-species support thin.",
  },
  high: {
    label: "high uncertainty",
    color: "hsl(var(--uncertainty-high))",
    explain:
      "Only indirect evidence (text mining / co-expression) or a single-species prediction. Treat as a hypothesis.",
  },
};

export function UncertaintyBadge({
  level,
  className,
}: {
  level: UncertaintyLevel;
  className?: string;
}) {
  const m = META[level];
  return (
    <Tooltip content={m.explain}>
      <span
        className={cn(
          "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
          className,
        )}
        style={{ borderColor: m.color, color: m.color }}
      >
        <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: m.color }} />
        {m.label}
      </span>
    </Tooltip>
  );
}
